module.exports = __webpack_public_path__ + "img/success-status.b0f8aea3.png";